import { ChatModuleType } from 'app/copied/models/ChatModules';
import useModule from 'app/hooks/useModule';

export default function usePdfTagsEnabled() {
  const kbModule = useModule(ChatModuleType.TAIlor);

  return !!kbModule?.config?.enable_hub_pdf_tags;
}
